import { getUserDetails } from 'api/getUserDetails';
import axios from 'axios';
import { generateGetHeaders } from 'api/generateGetHeaders';
import { useQuery } from 'react-query';

export const useStates = (businessName: string) => {
  return useQuery<string[], Error>(
    'states',
    async () => {
      const userDetails = await getUserDetails();
      const { data } = await axios.get(`${process.env.REACT_APP_API}/Portal/States`, generateGetHeaders(userDetails, businessName));
      return data;
    },
    { refetchOnWindowFocus: true }
  );
};
